import type { VsmContext, MasterPageConfigEntry, MasterPageConfigFn } from '@wix/thunderbolt-vsm-api'
import type { PasswordProtectedMasterPageConfig } from '../types'
import { PASSWORD_PROTECTED_PAGE_TRANSLATIONS, PASSWORD_PROTECTED_SITE_TRANSLATIONS } from '../translations'
import { name } from '../symbols'

const passwordProtectedPageMasterPageConfig: MasterPageConfigFn<PasswordProtectedMasterPageConfig> = ({
	api,
}: VsmContext) => {
	const translate = api.env.getTranslator()
	const pagePasswordDialogTranslations = {} as PasswordProtectedMasterPageConfig['pagePasswordDialogTranslations']
	const sitePasswordDialogTranslations = {} as PasswordProtectedMasterPageConfig['sitePasswordDialogTranslations']

	for (const [key, translation] of Object.entries(PASSWORD_PROTECTED_PAGE_TRANSLATIONS)) {
		const value = translate(translation.namespace, translation.key) ?? translation.default
		pagePasswordDialogTranslations[key as keyof typeof pagePasswordDialogTranslations] = value
	}
	for (const [key, translation] of Object.entries(PASSWORD_PROTECTED_SITE_TRANSLATIONS)) {
		const value = translate(translation.namespace, translation.key) ?? translation.default
		sitePasswordDialogTranslations[key as keyof typeof sitePasswordDialogTranslations] = value
	}

	return {
		pagePasswordDialogTranslations,
		sitePasswordDialogTranslations,
	}
}

export const masterPageConfig: MasterPageConfigEntry<PasswordProtectedMasterPageConfig> = {
	name,
	configFactory: passwordProtectedPageMasterPageConfig,
	experiment: 'specs.thunderbolt.vsmPageConfigs',
}
